import { DOC_TYPES_AMOUNT_LIMIT } from './DocSearchDropdown.constants';

export const cropDocTypes = <T extends unknown>(docTypes: T[], returnRest = false) => (!returnRest
  ? docTypes.slice(0, DOC_TYPES_AMOUNT_LIMIT)
  : docTypes.slice(DOC_TYPES_AMOUNT_LIMIT));
